// extracted by mini-css-extract-plugin
export default {"container":"services_container__K6tMe","feature-icon":"services_feature-icon__CTYHX","content_image":"services_content_image__8nnkK"};